import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { buildCampaignSettingsTabs } from '@helpers/campaign-navigation.helper';
import { RouteSymbols } from 'src/app/route-symbols';
import { CurrentUserService } from '../services/current-user.service';
import { getCampaignGuidFromRoute } from './access-verifier.guard';

/**
 * Entry redirect for /campaigns/:campaignGuid/settings: lands on the first tab the user may open.
 * Runs after the parent AccessVerifierGuard has loaded the user, unlike a redirectTo function.
 */
export const CampaignSettingsEntryGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const currentUserService = inject(CurrentUserService);
  const campaignGuid = getCampaignGuidFromRoute(route) ?? '';
  const firstTab = buildCampaignSettingsTabs(currentUserService, campaignGuid)[0]?.route ?? RouteSymbols.SettingsGeneralData;
  return router.createUrlTree([RouteSymbols.Campaigns, campaignGuid, RouteSymbols.Settings, firstTab]);
};
